/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Integrations_Credentials_Dialog_Connect_TitleInputs */



/**
* | output |
* | --- |
* | "Connect {name}" |
*
* @param {Integrations_Credentials_Dialog_Connect_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_dialog_connect_title = /** @type {((inputs: Integrations_Credentials_Dialog_Connect_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Dialog_Connect_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} verbinden`)
	return /** @type {LocalizedString} */ (`Connect ${i?.name}`)
});